import { createFileRoute } from "@tanstack/react-router";

import { MainPane } from "../components/MainPane";
import { TerminalWorkspace } from "../components/terminal/TerminalWorkspace";

export const Route = createFileRoute("/hosts/")({
  component: HostsIndex,
});

function HostsIndex() {
  return (
    <MainPane>
      <TerminalWorkspace className="flex-1" />
    </MainPane>
  );
}
